var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28003 8.00001H4.08003L5.20003 6.32001L7.44003 9.68001L8.56003 8.00001H10.24",
    stroke: "#94A3B8",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.007 5.76C1 5.669 1 5.571 1 5.48C1 4.63852 1.29155 3.82303 1.82503 3.17228C2.35852 2.52153 3.101 2.07572 3.92614 1.91069C4.75128 1.74566 5.6081 1.87161 6.35084 2.26712C7.09359 2.66263 7.67635 3.30325 8 4.08C8.32365 3.30325 8.90641 2.66263 9.64915 2.26712C10.3919 1.87161 11.2487 1.74566 12.0739 1.91069C12.899 2.07572 13.6415 2.52153 14.175 3.17228C14.7085 3.82303 15 4.63852 15 5.48C15 10.24 8 14.16 8 14.16C8 14.16 5.207 12.592 3.149 10.24",
    stroke: "#94A3B8",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCenterIcon);
export default __webpack_public_path__ + "static/media/health_center_icon.5d05f22e2d215a742240e09f8916853f.svg";
export { ForwardRef as ReactComponent };